import React from 'react';
import { createUseStyles } from 'react-jss';

function MzErrorMessage({error,visible,className, ...other}) {
const st=styles();



 if(!error|| !visible) return null;

  return (
            <small className={"p-error "+className}>{error}</small> 
  )

}

const styles = createUseStyles({
  container: {}
});

export default MzErrorMessage;